/**
 * ApprovalsPage — standalone full-page view of pending Harness pipeline approvals.
 *
 * Accessible to all authenticated users (no admin permission required).
 * Route: /approvals
 *
 * The panel (ApprovalsPanel) handles the sidebar + table layout.
 */

import { Page, Header, Content } from '@backstage/core-components';
import { ApprovalsPanel } from '../ApprovalsPanel/ApprovalsPanel';

export function ApprovalsPage() {
  return (
    <Page themeId="tool">
      <Header
        title="Approvals"
        subtitle="Workflow pipeline executions currently awaiting approval — open in Harness to approve or reject"
      />
      <Content>
        <ApprovalsPanel />
      </Content>
    </Page>
  );
}
